import { render, staticRenderFns } from "./GerkPrintIP.vue?vue&type=template&id=28e3f3ee&scoped=true&"
import script from "./GerkPrintIP.vue?vue&type=script&lang=js&"
export * from "./GerkPrintIP.vue?vue&type=script&lang=js&"
import style0 from "./GerkPrintIP.vue?vue&type=style&index=0&id=28e3f3ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3f3ee",
  null
  
)

export default component.exports